import heights from './theme.heights';
import layers from './theme.layers';

export default {
  heights,
  layers,
};
